<template>
  <v-container fluid>
    <back-btn />
    <v-row justify="center">
      <v-col lg="8">
        <v-card class="card--shadow">
          <v-card-subtitle
            >{{ volunteer.name }} - Training List</v-card-subtitle
          >
          <training-list :trainingData="trainingData" />
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import TrainingList from "@/components/volunteer/training/TrainingList";

import { mapState } from "vuex";
import BackBtn from "@/components/navigation/BackBtn.vue";

export default {
  components: {
    TrainingList,
    BackBtn,
  },
  data: () => ({
    cumps: [
      {
        text: "Home",
        disabled: false,
        href: "/",
      },
      {
        text: "Volunteer",
        disabled: false,
        href: "/volunteer",
      },
      {
        text: "Training",
        disabled: true,
      },
    ],
  }),
  computed: {
    ...mapState("Volunteer", ["volunteer", "trainingData"]),
  },
  created() {
    this.$store.dispatch("Volunteer/getVolunteer", this.$route.params.id);

    this.$store.dispatch(
      "Volunteer/getVolunteerTraining",
      this.$route.params.id
    );
  },
};
</script>

<style scoped>
.card--shadow {
  box-shadow: var(--primary-box-shadow) !important;
}
</style>
